import { readRemaining1kbpbgdrq25q1 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.q5g().d5j(), $completion));
  return SavedHttpCall().m5k(_this__u8e3s4.l5g_1, _this__u8e3s4.o5i(), _this__u8e3s4.q5g(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, request, response, responseBody) {
        return new.target.m5k(client, request, response, responseBody);
      }
      static m5k(client, request, response, responseBody) {
        var $this = this.n5i(client);
        $this.k5k_1 = responseBody;
        $this.n5g_1 = new (SavedHttpRequest())($this, request);
        $this.o5g_1 = new (SavedHttpResponse())($this, $this.k5k_1, response);
        checkContentLength(contentLength(response), fromInt($this.k5k_1.length), request.w5i());
        $this.l5k_1 = true;
        return $this;
      }
      q5i() {
        return this.l5k_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.n5k_1 = origin;
        this.o5k_1 = call;
      }
      v5i() {
        return this.o5k_1;
      }
      bw() {
        return this.n5k_1.bw();
      }
      w5i() {
        return this.n5k_1.w5i();
      }
      x5i() {
        return this.n5k_1.x5i();
      }
      p5i() {
        return this.n5k_1.p5i();
      }
      z2n() {
        return this.n5k_1.z2n();
      }
      v51() {
        return this.n5k_1.v51();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.p5k_1 = call;
        this.q5k_1 = body;
        this.r5k_1 = origin.e5j();
        this.s5k_1 = origin.f5j();
        this.t5k_1 = origin.g5j();
        this.u5k_1 = origin.h5j();
        this.v5k_1 = origin.v51();
        this.w5k_1 = origin.bw();
      }
      v5i() {
        return this.p5k_1;
      }
      e5j() {
        return this.r5k_1;
      }
      f5j() {
        return this.s5k_1;
      }
      g5j() {
        return this.t5k_1;
      }
      h5j() {
        return this.u5k_1;
      }
      v51() {
        return this.v5k_1;
      }
      bw() {
        return this.w5k_1;
      }
      d5j() {
        return ByteReadChannel(this.q5k_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as savemjbqee915hc5,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
